import { Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-aggiungi-news-backoffice',
  templateUrl: './aggiungi-news-backoffice.component.html',
  styleUrl: './aggiungi-news-backoffice.component.css'
})
export class AggiungiNewsBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router, private datePipe: DatePipe) { }  

  formNews!: FormGroup;

  ngOnInit(): void {    

    this.formNews = new FormGroup({
      titolo: new FormControl(null, Validators.required),
      data: new FormControl(null, Validators.required),
      descrizione: new FormControl(null),
      evidenzia: new FormControl(null),
      link: new FormControl(null),
      link_url: new FormControl(null)
    })
  }

  onLink(value: any) {
    if (value.length > 0) {
      this.formNews.get('link')?.setValidators(Validators.required);
    } else {
      this.formNews.get('link')?.clearValidators();
    }

    this.formNews.get('link')?.updateValueAndValidity();

  }

  onSubmit() {

    let news = {
      titolo: this.formNews.get('titolo')?.value,
      data: this.datePipe.transform(this.formNews.get('data')?.value, 'yyyy-MM-dd') || '',
      descrizione: this.formNews.get('descrizione')?.value || '',
      evidenzia: this.formNews.get('evidenzia')?.value ? (this.formNews.get('evidenzia')?.value.length > 0 ? true : false) : false,
      link: this.formNews.get('link')?.value ? (this.formNews.get('link')?.value.length > 0 ? true : false) : false,
      link_url: this.formNews.get('link_url')?.value || ''
    }
 
    this.apiService.addNotizia(news).subscribe({
      next: (data) => this.apiService.setNotizie(),        
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/news'])
      }
    })

  }

}